import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { Usuario } from '../usuario';
import { UsuarioService } from '../usuario.service';

@Component({
  selector: 'app-usuario-list',
  templateUrl: './usuario-list.component.html',
  styleUrls: ['./usuario-list.component.css']
})
export class UsuarioListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['name', 'username', 'perfil', 'details'];

  constructor(private usuarioService: UsuarioService, router: Router, dialog: MatDialog) {

    super(router, dialog);
  }

  ngOnInit() {
    this.reloadData();

    super.ngOnInit();
  }

  reloadData() {
    this.usuarioService.listar()
      .subscribe(data => {
        // console.log(data)
        this.data = data;
        this.configurarDataSource();
      }, error => {
        console.log(error);
      });
  }

  confirmDelete(id: string) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: string) {
    this.usuarioService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterUsuario']);
  }

  details(id: string) {
    this.router.navigate(['manterUsuario'], {
      state: {
        id: id,
        isUpdate: 'N',
        usuario: this.getUsuarioSelecionado(id)
      }
    });
  }

  update(id: string) {
    this.router.navigate(['manterUsuario'], {
      state: {
        id: id,
        isUpdate: 'S',
        usuario: this.getUsuarioSelecionado(id)
      }
    });
  }

  getUsuarioSelecionado(idUsuarioSelecionado: string): Usuario | null {

    if (this.data) {
      let currentUsuario: any = this.data.find((obj: { username: string; }) => obj.username == idUsuarioSelecionado);

      return currentUsuario as Usuario;
    }

    return null;
  }
}
